import { render, staticRenderFns } from "./addDoc.vue?vue&type=template&id=49e25e8c"
import script from "./addDoc.vue?vue&type=script&lang=js"
export * from "./addDoc.vue?vue&type=script&lang=js"
import style0 from "./addDoc.vue?vue&type=style&index=0&id=49e25e8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports